import React, {useState, useEffect} from 'react';
import {Autocomplete, TextField} from '@mui/material';
import './ArrAutocomplete.scss';

export interface ArrAutocompleteProps {
  options: any[];
  value: any;
  enabled?: boolean;
  onChange?: (value: string) => void;
  children?: React.ReactNode;
  className?: string;
  anchorEl?: HTMLElement | null;
}

const ArrAutocomplete: React.FC<ArrAutocompleteProps> = ({
  options,
  value,
  enabled,
  onChange,
  children,
  className,
  anchorEl,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    let hasMatch = false;
    if (value && options && options.length) {
      hasMatch = options.some((i) => {
        // Perform case-insensitive string comparison
        const option = `${i}`.toLocaleLowerCase();
        const input = `${value}`.toLocaleLowerCase();
        return option.includes(input);
      });
    }
    setIsOpen(hasMatch);
  }, [value, options]);

  return (
    <>
      {children}
      {enabled && (
        <Autocomplete
          freeSolo
          className={`arr-autocomplete ${className}`}
          classes={{
            popper: isOpen
              ? 'arr-autocomplete_visible'
              : 'arr-autocomplete_hidden',
          }}
          options={options}
          inputValue={value}
          onInputChange={(event, value) => onChange?.(value)}
          open={isOpen}
          onOpen={() => setIsOpen(true)}
          onClose={() => setIsOpen(false)}
          slotProps={{
            popper: {
              modifiers: [{name: 'preventOverflow', enabled: true}],
              placement: 'bottom-start',
              ...(anchorEl ? {anchorEl} : {}),
            },
          }}
          sx={{
            maxHeight: '1px',
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              disabled
              tabIndex={-1}
              className={`arr-autocomplete__input ${className}__input`}
              sx={{
                maxHeight: '1px',
                opacity: '0',
                marginTop: '-58px',
                zIndex: '-1',
              }}
            />
          )}
        />
      )}
    </>
  );
};

export default ArrAutocomplete;
